import { useEffect, useState } from "react";
import { DataTableColumn } from "../../../../components/common/datatable/DataTableTypes";
import { createClickableLink } from "../../../../components/common/datatable/DataTableUtils";
import { SearchInputWrapper } from "../../../../components/common/datatable/filter/SearchInputWrapper";
import Breadcrumb from "../../../../components/common/Breadcrumbs";
import { DataTable } from "../../../../components/common/datatable/DataTable";
import IconButton from "../../../../components/common/form/IconButton";
import { FaPlus } from "react-icons/fa6";
import { useLazyExportManagementCompanyDataQuery, useSearchManagementCompanyApiQuery } from "../managementCompany";
import { useNavigate } from "react-router-dom";
import { useFindUserSettingsByGroupNameQuery } from "../../../../components/common/userSetting/userSettingsApi";
import { hasPermission } from "../../../../helpers/utils/AccessControlUtils";


const ManagementCompany = () => {

    const { data: userSetting } = useFindUserSettingsByGroupNameQuery("Management Company");

    const [triggerExportManagementCompanyDataQuery] = useLazyExportManagementCompanyDataQuery();
    const navigate = useNavigate();
    const [crumbs] = useState([
        { content: "Home", url: "/home" },
        { content: "Management Companies", url: "" }]
    )
    useEffect(() => {
        document.title = 'Management Companies';
    }, []);

    const columns: DataTableColumn[] = [
        {
            label: "Name", accessor: "name", visibility: { hasShowSetting: false },
            cell: (props: any) => {
                if (hasPermission(["MGTCOM-R"])) {
                    let path = "/management-companies/" + props.row.original.id;
                    return createClickableLink(path, props.value, userSetting);
                } else {
                    return <>
                        <span>{props.row.original.name}</span>
                    </>
                }
            },
            filterOptions: [{
                filterComponent: <SearchInputWrapper type={"text"} placeholder={"Enter Name..."}
                    name={"managementCompanyName"} accessor={"name"} />,
                overrideFilterAccessor: "name"
            }],
        }
    ]

    return (
        <div className="px-4 py-2">
            <div className="flex justify-between mb-2.5">
                <Breadcrumb crumbs={crumbs} />
            </div>

            <DataTable
                columns={columns}
                actions={{
                    fetchAction: useSearchManagementCompanyApiQuery,
                    exportAction: triggerExportManagementCompanyDataQuery
                }}
                buttonOptions={{
                    addButton:
                    {
                        button: <IconButton
                            icon={<FaPlus />}
                            hasBackground={true}

                            onClick={() => {
                                navigate("/management-companies/create")
                            }}
                            title={"Create Management Company"}
                        />,
                        permissions: ["MGTCOM-C"]
                    },
                }}
                userSettingGroup={"Management Company"}
                defaultSortOptions={{
                    accessor: "name",
                    direction: "asc"
                }}
                basePermission={"MGTCOM"}
            />
        </div>
    );
}

export default ManagementCompany;